const hideLayer = layerName => ({
    'OUTFALL': false,
    'JUNCTION': false,
    'STORAGE': false,
    'RAIN GAUGE': false,
    'CONDUIT': false,
    'PUMP': false
}[layerName] || false);

export default hideLayer